import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { DataLakeBackends } from "@graylog/enterprise-api";
import { DATA_LAKE_BACKEND_QUERY_KEYS } from "data-lake/Constants";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = [];
const refetchInterval = 5e3;
const fetchConfig = () => DataLakeBackends.getAll();
const useDataLakeBackends = ({ enabled } = { enabled: true }) => {
  const { data, refetch, isInitialLoading } = useQuery({
    queryKey: [...DATA_LAKE_BACKEND_QUERY_KEYS],
    queryFn: () => defaultOnError(
      fetchConfig(),
      "Loading Data Lake backends failed with status",
      "Could not load Data Lake backends."
    ),
    placeholderData: keepPreviousData,
    refetchInterval,
    notifyOnChangeProps: ["data", "error"],
    enabled
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    refetch,
    isInitialLoading
  };
};
export default useDataLakeBackends;
